const adapters = {
  localStorage: {
    setItem: (key, value) => localStorage.setItem(key, JSON.stringify(value)),
    getItem: key => JSON.parse(localStorage.getItem(key)),
    removeItem: key => localStorage.removeItem(key),
  }
};

let storageDriver = "localStorage";

export const storage = {
  setStorageDriver: driver => (storageDriver = driver),
  setItem: (...args) => adapters[storageDriver].setItem(...args),
  getItem: (...args) => adapters[storageDriver].getItem(...args),
  removeItem: (...args) => adapters[storageDriver].removeItem(...args),
};
